<template>
    <div>
        <transition name="fade">
            <div v-if="loading" class="madrid-loading">
                <svg
                    id="loading"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 -24 60 48"
                    enable-background="new 0 0 0 0"
                    xml:space="preserve"
                >
                    <circle fill="#fff" stroke="none" cx="6" cy="0" r="6">
                        <animateTransform
                            attributeName="transform"
                            dur="1s"
                            type="translate"
                            values="0 15 ; 0 -15; 0 15"
                            repeatCount="indefinite"
                            begin="0.1"
                        />
                    </circle>
                    <circle fill="#fff" stroke="none" cx="30" cy="0" r="6">
                        <animateTransform
                            attributeName="transform"
                            dur="1s"
                            type="translate"
                            values="0 10 ; 0 -10; 0 10"
                            repeatCount="indefinite"
                            begin="0.2"
                        />
                    </circle>
                    <circle fill="#fff" stroke="none" cx="54" cy="0" r="6">
                        <animateTransform
                            attributeName="transform"
                            dur="1s"
                            type="translate"
                            values="0 5 ; 0 -5; 0 5"
                            repeatCount="indefinite"
                            begin="0.3"
                        />
                    </circle>
                </svg>
            </div>
        </transition>
        <iframe
            id="visor"
            ref="onirixIframe"
            :style="
                computedStyle
            "
            :src="url"
            allow="web-share;camera;gyroscope;accelerometer;magnetometer;fullscreen;xr-spatial-tracking;geolocation;"
        >
        </iframe>
        <div v-if="showData" class="madrid-location-data" :class="{'madrid-location-data--ar': currentLocation.ar}">
            <div class="madrid-location-data__header">
                <div class="madrid-location-data__back" @click="close()"></div>
                <div>
                    <span>{{ route.name }}</span>
                    <span>PARADA {{ index + 1 }}</span>
                </div>
                <h1>{{ currentLocation.name }}</h1>
            </div>
            <img v-if="currentLocation.image_ant != ''" class="madrid-location-data__image" 
                :src="currentLocation.image_ant"/>
            <p class="madrid-location-data__author madrid-location-data__author-ant" 
                v-if="currentLocation.author_ant">Foto antes: <span>{{ currentLocation.author_ant }}</span></p>
                <img class="madrid-location-data__image" 
                :src="currentLocation.image"/>
            <p class="madrid-location-data__author" 
                v-if="currentLocation.author">Foto después: <span>{{ currentLocation.author }}</span></p>
            <p>{{ currentLocation.description }}</p>
            <div class="madrid-location-data__bottom">
                <div @click="scrollToTop()">
                    <span>VOLVER ARRIBA</span>
                    <span></span>
                </div>
                <div></div>
            </div>
        </div>
        <madrid-quiz v-if="showQuiz" @goTo="hideQuiz" :route="route.name" 
        :type="QuizType.FINAL" :location="currentLocation.name"></madrid-quiz>
    </div>
</template>
<script src="./MapComponent.ts" lang="ts"></script>
<style src="./MapComponent.scss" lang="scss"></style>
